import { API_URL } from '../api';
import { resourceActions } from '../resources/slice';
import { themeActions } from '../themes/slice';
import { SyncableAction, SyncableActionTypes, SyncResponse } from './types';

const SYNC_URL = `${API_URL}/sync`;

const TYPES_MAP: Record<SyncableActionTypes, string> = {
  [resourceActions.deleteResource.type]: 'resource/DELETE',
  'saveResource': 'resource/PUT',
  [themeActions.saveTheme.type]: 'theme/PUT',
  [themeActions.deleteTheme.type]: 'theme/DELETE'
};

class CouldNotSyncError extends Error {}

export const makeSyncRequest = async (queue: SyncableAction[] = [], lastSync: number = 0): Promise<SyncResponse> => {
  const actions = queue.map(
    q => ({
      ...q,
      type: TYPES_MAP[q.type],
      theme: q.type.startsWith('theme') ? q.payload : undefined,
      resource: q.type.startsWith('resource') ? q.payload : undefined,
      payload: undefined
    })
  );

  const result = await fetch(
    SYNC_URL,
    {
      method: 'post',
      body: JSON.stringify({
        actions,
        lastSync: lastSync / 1000 // JS to Python timestamp
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (!result.ok) {
    throw new CouldNotSyncError(result.statusText);
  }
  if (result.status === 204) {
    // No content
    return { actions: [] };
  }
  const body = await result.json();
  return body as SyncResponse;
};
